import { Component } from 'react'
import PropTypes from 'prop-types'
import Actions from '../../../../actions'
import Operations from '../../../../operations'
import { connect } from 'react-redux'
import Selectors from '../../../../selectors'
import { get } from 'lodash'
import { showToast } from '../../../../common/utils'
import { DocumentsPaywall } from './components/DocumentsPaywall'
import { DocumentList, Spinner } from '../../../../components/generic'
import ConfirmationDialog from '../../../../LEGACY/ConfirmationDialog'
import { sizes } from '@lmc/common/constants'
import { ButtonOLD, EmptyState, NotStartedIcon } from '@lmc/ui-kit'
import Glyph from '../../../../LEGACY/Glyph'

export class OrganisationDocumentsScreen extends Component {
  state = {
    documentsFetchInterval: null,
    documentToDelete: null,
  }

  componentDidMount() {
    const { fetchDocuments } = this.props
    this.setState({
      documentsFetchInterval: setInterval(fetchDocuments, 600000),
    })
    fetchDocuments()
  }

  componentWillUnmount() {
    clearInterval(this.state.documentsFetchInterval)
  }

  openDialog = (id) => this.setState({ documentToDelete: id })

  closeDialog = () => this.setState({ documentToDelete: null })

  handleDelete = () => {
    this.props.deleteDocument(this.state.documentToDelete)
    showToast({ type: 'info', title: 'Deleted a Document' })
    this.closeDialog()
  }

  render() {
    const {
      documents,
      features,
      openCreateModal,
      openEditModal,
      isLoading,
      carePlanNominative,
    } = this.props

    if (isLoading) return <Spinner />

    if (!features?.features?.homeDocuments?.enabled) {
      return <DocumentsPaywall />
    }

    const hasDocuments = !!Object.keys(documents).length

    return (
      <div style={styles.wrapper}>
        <div style={styles.createButtonContainer}>
          <ButtonOLD
            onClick={openCreateModal}
            type="primary"
            icon={<Glyph name="plus" />}
          >
            Add a Document
          </ButtonOLD>
        </div>
        {hasDocuments ? (
          <DocumentList
            documents={documents}
            listId="home-documents"
            onDelete={this.openDialog}
            onEdit={openEditModal}
            carePlanNominative={carePlanNominative}
          />
        ) : (
          <EmptyState
            title={NO_DOCUMENTS_MESSAGE}
            description={NO_DOCUMENTS_SUBHEADING}
            icon={<NotStartedIcon />}
          />
        )}
        <ConfirmationDialog
          confirmationType="warning"
          isOpen={!!this.state.documentToDelete}
          onCancel={this.closeDialog}
          onConfirmation={this.handleDelete}
        >
          <div>
            Are you sure you want to delete this document? If you go ahead, it
            can’t be undone. Once it's gone, it’s gone for good!
          </div>
        </ConfirmationDialog>
      </div>
    )
  }
}

const MODAL_ID = 'documentModal'

const NO_DOCUMENTS_MESSAGE = "You haven't added any documents for your home"
const NO_DOCUMENTS_SUBHEADING =
  'Upload your Policies and Procedures here so that your care team can read them whenever they need from the Carer App.'

const styles = {
  createButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    minHeight: 34,
    paddingBottom: 20,
  },
  noDocumentsMessage: {
    position: 'relative',
    top: 50,
  },
  wrapper: {
    margin: '0 auto',
    width: '100%',
    maxWidth: sizes.childScreen,
    padding: '24px',
  },
}

OrganisationDocumentsScreen.propTypes = {
  documents: PropTypes.object,
  deleteDocument: PropTypes.func.isRequired,
  features: PropTypes.object,
  fetchDocuments: PropTypes.func.isRequired,
  openCreateModal: PropTypes.func.isRequired,
  openEditModal: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  documents: Selectors.groupHomeDocuments(state),
  carePlanNominative: state.global.home.preferredCarePlansNominative,
  features: state.global.home,
  isLoading: !state.data['home-documents'] || !state.global.home,
  home: get(state, 'global.user.home'),
})

const mapDispatchToProps = (dispatch) => ({
  fetchDocuments: () => {
    dispatch(Operations.loadList('home-documents'))
    dispatch(Operations.loadList('home-document-categories'))
  },
  deleteDocument: (id) =>
    dispatch(Operations.deleteDocument(id, 'home-documents')),
  openCreateModal: () => {
    dispatch(
      Actions.openModal({
        modalId: MODAL_ID,
        data: { listId: 'home-documents', type: 'create' },
      })
    )
    dispatch(Actions.addForm({ formId: MODAL_ID }))
  },
  openEditModal: (document) => {
    dispatch(
      Actions.openModal({
        modalId: MODAL_ID,
        data: { listId: 'home-documents', type: 'edit' },
      })
    )
    dispatch(
      Actions.addForm({
        formId: MODAL_ID,
        initial: document,
      })
    )
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganisationDocumentsScreen)
